import * as Cesium from "cesium";
import { CesiumCursor } from "./CesiumCursor";
import { MarkerEntityType } from "./MarkerEntityType";

const DEFAULT_SECONDARY_MARKER_SCALE = 0.25;

export function generateSecondaryMarker(
  sourceEntity: Cesium.Entity,
  origin: number[],
  pixelOffset: Cesium.Cartesian2,
): Cesium.Entity {
  return new Cesium.Entity({
    position: Cesium.Cartesian3.fromDegrees(origin[0], origin[1]),
    billboard: new Cesium.BillboardGraphics({
      image: sourceEntity.billboard.image,
      scale: DEFAULT_SECONDARY_MARKER_SCALE,
      heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
      disableDepthTestDistance: Number.POSITIVE_INFINITY,
      pixelOffset: new Cesium.Cartesian2(pixelOffset.x, pixelOffset.y),
    }),
    properties: {
      type: MarkerEntityType.SecondaryMarker,
      coordinates: sourceEntity.properties.coordinates.valueOf(),
      tooltipPixelOffset: new Cesium.Cartesian2(
        pixelOffset.x,
        pixelOffset.y - 50,
      ),
      onClick: sourceEntity.properties.onClick,
      tooltipText: sourceEntity.properties.tooltipText,
      cursor: CesiumCursor.pointer,
    },
  });
}
